unit unit_Bestellungen;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, WEBLib.Grids, Data.DB, strutils,
  XData.Web.JsonDataset, XData.Web.Dataset, Vcl.StdCtrls, WEBLib.StdCtrls, DB;

type
  TBestellungen = class(TForm)
    xdsBestellungen: TXDataWebDataSet;
    xdsBestellungenKundennummer: TXDataWebEntityField;
    xdsBestellungenNummerkomplett: TStringField;
    xdsBestellungenDatum: TDateTimeField;
    xdsBestellungenJahr: TFloatField;
    xdsBestellungenAuftragsbezeichnung: TStringField;
    xdsBestellungenBruttosumme: TFloatField;
    TC: TTableControl;
    procedure WebFormShow(Sender: TObject);
    procedure xdsBestellungenAfterOpen(DataSet: TDataSet);
  private
    { Private-Deklarationen }
  public
    { Public-Deklarationen }
        Belegnummer:string;
    mybuttonDetails:TButton;
    buttonzurueck:TButton;
    procedure buttonzurueckclick(Sender:TObject);
    procedure mybuttonDetailsclick(Sender:TObject);
  protected procedure LoadDFMValues; override; end;

var
  Bestellungen: TBestellungen;

implementation
  uses unit1, unit2, unit_EinzelBeleg;
{$R *.dfm}

procedure TBestellungen.buttonzurueckclick(Sender:TObject);
begin
  close;
end;

procedure TBestellungen.mybuttonDetailsclick(Sender:TObject);
var
  EinzelBeleg:TEinzelBeleg;
    procedure AfterCreate(AForm:TObject);
    begin
      with sender as TButton do
      begin
        Belegnummer:=tc.Cells[0,tag];
        Belegnummer:=replacestr(Belegnummer,'<b>','');
        Belegnummer:=replacestr(Belegnummer,'</b>','');
      end;
      (AForm as TEinzelBeleg).Belegnummer:=Belegnummer;
      (AForm as TEinzelBeleg).Belegart:='Aufträge';
    end;

    procedure AfterShowmodal(Avalue:TModalResult);
    begin
      //nothing to do
    end;

  begin

  EinzelBeleg:=TEinzelBeleg.CreateNew(@AfterCreate);
  EinzelBeleg.ShowModal(@AfterShowmodal);

end;

procedure TBestellungen.WebFormShow(Sender: TObject);
begin
  xdsBestellungen.Close;
  xdsBestellungen.QueryString:='$filter=Kundennummer eq '+QuotedStr(KundeKundennummer)+'&$orderby=Nummerkomplett DESC' ;
  xdsBestellungen.Load;
end;

procedure TBestellungen.xdsBestellungenAfterOpen(DataSet: TDataSet);
var
  temptext:string;
  i:integer;
  myelement:TJSHTMLElement;
begin
  TC.ColCount:=5;
  tc.RowCount:=xdsBestellungen.RecordCount+3;
  TC.Cells[0,0]:='<h4>Bestellungen (Aufträge)';
  inc(i);
  myelement:=TC.cellelements[0,i];
  buttonzurueck:=TButton.Create(self);
  buttonzurueck.ElementClassName:='btn btn-info text-left';
  buttonzurueck.HeightStyle:=ssauto;
  buttonzurueck.WidthStyle:=ssauto;
  buttonzurueck.tag:=0;
  buttonzurueck.Caption:='<< zurück';
  buttonzurueck.OnClick:=@buttonzurueckClick;
  buttonzurueck.ParentElement:=myelement;

  inc(i);
  tc.Cells[0,i]:='<b>Auftrags-Nr.';
  tc.Cells[1,i]:='<b>Datum';
  tc.Cells[2,i]:='<b>Bezeichnung';
  tc.Cells[3,i]:='<b>Betrag';
  tc.Cells[4,i]:='<b>Details';
  xdsBestellungen.First;
  while not xdsBestellungen.eof do
  begin
    inc(i);
    tc.Cells[0,i]:='<b>'+xdsBestellungenNummerkomplett.AsString+'</b>';
    tc.Cells[1,i]:=formatdatetime('DD.MM.YYYY',xdsBestellungenDatum.Asdatetime);
    tc.Cells[2,i]:=xdsBestellungenAuftragsbezeichnung.AsString;
    tc.Cells[3,i]:='<p class="text-right">'+formatfloat('#,##0.00',xdsBestellungenBruttosumme.Asfloat);


    myelement:=TC.cellelements[4,i];
    mybuttonDetails:=TButton.Create(self);
    mybuttonDetails.ElementClassName:='btn btn-info text-left';
    mybuttonDetails.HeightStyle:=ssauto;
    mybuttonDetails.WidthStyle:=ssauto;
    mybuttonDetails.tag:=i;
    mybuttonDetails.Caption:='Details';
    mybuttonDetails.OnClick:=@mybuttonDetailsclick;
    mybuttonDetails.ParentElement:=myelement;
    xdsBestellungen.Next;
  end;

end;

procedure TBestellungen.LoadDFMValues;
begin
  inherited LoadDFMValues;

  TC := TTableControl.Create(Self);
  xdsBestellungen := TXDataWebDataSet.Create(Self);
  xdsBestellungenKundennummer := TXDataWebEntityField.Create(Self);
  xdsBestellungenNummerkomplett := TStringField.Create(Self);
  xdsBestellungenDatum := TDateTimeField.Create(Self);
  xdsBestellungenJahr := TFloatField.Create(Self);
  xdsBestellungenAuftragsbezeichnung := TStringField.Create(Self);
  xdsBestellungenBruttosumme := TFloatField.Create(Self);

  TC.BeforeLoadDFMValues;
  xdsBestellungen.BeforeLoadDFMValues;
  xdsBestellungenKundennummer.BeforeLoadDFMValues;
  xdsBestellungenNummerkomplett.BeforeLoadDFMValues;
  xdsBestellungenDatum.BeforeLoadDFMValues;
  xdsBestellungenJahr.BeforeLoadDFMValues;
  xdsBestellungenAuftragsbezeichnung.BeforeLoadDFMValues;
  xdsBestellungenBruttosumme.BeforeLoadDFMValues;
  try
    Name := 'Bestellungen';
    Width := 167;
    Height := 299;
    Caption := 'Bestellungen';
    CSSLibrary := cssBootstrap;
    ElementFont := efCSS;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    TC.SetParentComponent(Self);
    TC.Name := 'TC';
    TC.Left := 0;
    TC.Top := 0;
    TC.Width := 121;
    TC.Height := 217;
    TC.ElementClassName := 'table table-hover table-bordered table-striped';
    TC.HeightStyle := ssAuto;
    TC.WidthStyle := ssPercent;
    TC.BorderColor := clSilver;
    TC.ChildOrder := 2;
    TC.ColHeader := False;
    TC.ElementHeaderClassName := 'table-info';
    TC.ElementTableClassName := 'table table-hover table-bordered table-striped';
    TC.WordWrap := True;
    TC.ColCount := 2;
    xdsBestellungen.SetParentComponent(Self);
    xdsBestellungen.Name := 'xdsBestellungen';
    xdsBestellungen.AfterOpen := xdsBestellungenAfterOpen;
    xdsBestellungen.EntitySetName := 'Auftrag';
    xdsBestellungen.Connection := DM2.XDataWebConnection1;
    xdsBestellungen.Left := 40;
    xdsBestellungen.Top := 40;
    xdsBestellungenKundennummer.SetParentComponent(xdsBestellungen);
    xdsBestellungenKundennummer.Name := 'xdsBestellungenKundennummer';
    xdsBestellungenKundennummer.FieldName := 'Kundennummer';
    xdsBestellungenKundennummer.Required := True;
    xdsBestellungenNummerkomplett.SetParentComponent(xdsBestellungen);
    xdsBestellungenNummerkomplett.Name := 'xdsBestellungenNummerkomplett';
    xdsBestellungenNummerkomplett.FieldName := 'Nummerkomplett';
    xdsBestellungenNummerkomplett.Required := True;
    xdsBestellungenNummerkomplett.Size := 10;
    xdsBestellungenDatum.SetParentComponent(xdsBestellungen);
    xdsBestellungenDatum.Name := 'xdsBestellungenDatum';
    xdsBestellungenDatum.FieldName := 'Datum';
    xdsBestellungenDatum.Required := True;
    xdsBestellungenJahr.SetParentComponent(xdsBestellungen);
    xdsBestellungenJahr.Name := 'xdsBestellungenJahr';
    xdsBestellungenJahr.FieldName := 'Jahr';
    xdsBestellungenAuftragsbezeichnung.SetParentComponent(xdsBestellungen);
    xdsBestellungenAuftragsbezeichnung.Name := 'xdsBestellungenAuftragsbezeichnung';
    xdsBestellungenAuftragsbezeichnung.FieldName := 'Auftragsbezeichnung';
    xdsBestellungenAuftragsbezeichnung.Size := 255;
    xdsBestellungenBruttosumme.SetParentComponent(xdsBestellungen);
    xdsBestellungenBruttosumme.Name := 'xdsBestellungenBruttosumme';
    xdsBestellungenBruttosumme.FieldName := 'Bruttosumme';
  finally
    TC.AfterLoadDFMValues;
    xdsBestellungen.AfterLoadDFMValues;
    xdsBestellungenKundennummer.AfterLoadDFMValues;
    xdsBestellungenNummerkomplett.AfterLoadDFMValues;
    xdsBestellungenDatum.AfterLoadDFMValues;
    xdsBestellungenJahr.AfterLoadDFMValues;
    xdsBestellungenAuftragsbezeichnung.AfterLoadDFMValues;
    xdsBestellungenBruttosumme.AfterLoadDFMValues;
  end;
end;

end.